import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityDoc } from "../../entity/EntityDoc";

export class DtoDocsPostReq extends EntityDoc {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
